import { Directive } from "@angular/core";
import { NG_VALIDATORS, Validator, AbstractControl } from "@angular/forms"
import { RegExHelper } from "../bundles/helpers.bundle";

@Directive({
    selector: "[thresholdValidator]",
    providers: [{ provide: NG_VALIDATORS, useExisting: ThresholdValidatorDirective, multi: true }]
})
export class ThresholdValidatorDirective implements Validator {
    validate(control: AbstractControl) {
        const value = control.value;

        // Empty Value
        if (!value) {
            return null;
        }

        // decimal numbers from 1-100
        if (!RegExHelper.decimalsOnly.test(value)) {
            return { 'invalid': true };
        }

        return null;
    }
}